"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizedAppWrap = void 0;
const AuthorizedAppWrap_1 = __importDefault(require("./AuthorizedAppWrap"));
exports.AuthorizedAppWrap = AuthorizedAppWrap_1.default;
//# sourceMappingURL=index.js.map